<div class="mat-typography wba-kalender">
  <div class="content">
    <kalender-picker *ngIf="data" [zeitraum]="data.data.data[0]" [aktuelles_datum]="data.data.data[4]" [modus]="data.data.data[2]"></kalender-picker>
  </div>
</div>
